module.exports = __webpack_public_path__ + "img/case2-大搜车.742299db.png";